import { render, staticRenderFns } from "./CourseDetailCredentials.vue?vue&type=template&id=73bdbd8a"
import script from "./CourseDetailCredentials.vue?vue&type=script&lang=js"
export * from "./CourseDetailCredentials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports